import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { bookingCheckinSettingsService } from "@/services/booking-checkin-settings.service";

export const useCheckinServiceLists = (hotelId: string) => {
    const queryClient = useQueryClient();

    const checkinRecommended = useQuery({
        queryKey: ["checkinRecommendedServices", hotelId],
        queryFn: () => bookingCheckinSettingsService.getCheckinRecommendedServices(hotelId),
        enabled: !!hotelId,
    });

    const checkinFeatured = useQuery({
        queryKey: ["checkinFeaturedActivities", hotelId],
        queryFn: () => bookingCheckinSettingsService.getCheckinFeaturedActivities(hotelId),
        enabled: !!hotelId,
    });

    const bookingUpsell = useQuery({
        queryKey: ["bookingCheckinUpsellServices", hotelId],
        queryFn: () => bookingCheckinSettingsService.getBookingCheckinUpsellServices(hotelId),
        enabled: !!hotelId,
    });

    const updateCheckinRecommended = useMutation({
        mutationFn: (serviceIds: string[]) =>
            bookingCheckinSettingsService.updateCheckinRecommendedServices(hotelId, serviceIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["checkinRecommendedServices", hotelId] });
        },
    });

    const updateCheckinFeatured = useMutation({
        mutationFn: (serviceIds: string[]) =>
            bookingCheckinSettingsService.updateCheckinFeaturedActivities(hotelId, serviceIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["checkinFeaturedActivities", hotelId] });
        },
    });

    const updateBookingUpsell = useMutation({
        mutationFn: (serviceIds: string[]) =>
            bookingCheckinSettingsService.updateBookingCheckinUpsellServices(hotelId, serviceIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["bookingCheckinUpsellServices", hotelId] });
        },
    });

    return {
        checkinRecommended,
        checkinFeatured,
        bookingUpsell,
        updateCheckinRecommended,
        updateCheckinFeatured,
        updateBookingUpsell,
    };
};
